
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/code-of-ethics",
      function () {
        return require("private-next-pages/company/code-of-ethics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/code-of-ethics"])
      });
    }
  